"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcHTMLSanitizer = void 0;
var TAG_CONTENT = '[a-zñA-Z0-9áéíóúäëïöüÁÉÍÓÚÄËÏÖÜ!@#%&?¡¿°|:¬\[\*~`^\-_\]\$\t\\\n\(\)"\'/,; =><{}\.]';
var EMBBED_TAG_HTML = /<[a-zA-Z0-9]+(?: [a-zA-Z]+="[^"]*")*>[^<>]*<\/[a-zA-Z]+>/g;
var BcHTMLSanitizer = (function () {
    function BcHTMLSanitizer() {
    }
    BcHTMLSanitizer.prototype.sanitize = function (text) {
        return text.replace((EMBBED_TAG_HTML), '');
    };
    return BcHTMLSanitizer;
}());
exports.BcHTMLSanitizer = BcHTMLSanitizer;
